import React from 'react';
import { Box, Text } from 'grommet';
import { useRouter } from 'next/router';
import Button from '../Button';

const ChartRow = ({ name, value, detail, href, event, children }) => {
    const router = useRouter();
    const row = (
        <Box gap="xxsmall" pad={{ vertical: children ? 'xsmall' : 'xxsmall', horizontal: 'xxsmall' }}>
            <Box direction="row" justify="between" align="center" gap="small">
                <Box flex style={{ minWidth: 0 }}><Text truncate>{name}</Text></Box>
                <Box direction="row" gap="small" align="center" flex={false}>
                    <Text>{value}</Text>
                    {detail && <Box width={{ min: '48px' }} align="end"><Text size="small" color="text-weak">{detail}</Text></Box>}
                </Box>
            </Box>
            {children}
        </Box>
    );
    if (!href) return row;
    return <Button event={event} hoverIndicator onClick={() => router.push(href)}>{row}</Button>;
};

export default ChartRow;
